module.exports = __webpack_public_path__ + "img/5.018d9d64.jpg";